import Vue from 'vue'
import moment from  'moment'
moment.locale('ru')
Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})
Vue.filter('month', function (val, showYear = true) {
	val = String(val)

	const regx = /\w+\s(\w+)\s\d+\s(\d+)./
	if (!showYear) {
		return regx.exec(val)[1]
	} else {
		return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`
	}

})

Vue.filter('date', function(val){
	return moment(val).format("DD.MM.YYYY hh:mm")
})
Vue.filter('time', function(val){
	return moment(val).format("hh:mm")
})
Vue.filter('date_with_day_of_week', function(val){
	return moment(val).format("dddd, D MMMM  YYYY")
})
Vue.filter('capitalize_first', function(val){
	return val[0].toUpperCase() + val.slice(1)
})
